import React from 'react';
import './Heading.css'

const Heading = ({ text }) => {
    return (<div className='heading'>{ text }</div>)
}

export default Heading;